import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home, PackageX } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const NotFound = () => {
  return (
    <section className="min-h-screen w-screen overflow-hidden bg-gradient-to-br from-[#fff9ef] via-white to-[#fff4cf] font-Poppins text-slate-900">
      <Navbar />

      <main className="relative flex min-h-[calc(100vh-90px)] items-center justify-center px-5 pb-16 pt-[120px]">
        <div className="absolute left-[-120px] top-24 h-72 w-72 rounded-full bg-yellow-200/60 blur-3xl" />
        <div className="absolute bottom-16 right-[-120px] h-80 w-80 rounded-full bg-orange-200/60 blur-3xl" />

        <div className="relative z-10 w-full max-w-3xl text-center">
          <div className="mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-white shadow-2xl ring-8 ring-yellow-100">
            <PackageX className="h-12 w-12 text-yellow-500" />
          </div>

          <p className="mb-3 text-sm font-bold uppercase tracking-[0.35em] text-yellow-600">
            404 Not Found
          </p>
          <h1 className="text-4xl font-black leading-tight text-slate-950 sm:text-6xl">
            This delivery route does not exist
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-8 text-slate-600 sm:text-lg">
            The page you opened may have been moved, removed, or typed
            incorrectly. You can return to Instaport Delivery and continue from
            the home page.
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to="/"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-yellow-400 px-7 py-3 font-bold text-slate-950 shadow-lg shadow-yellow-300/40 transition hover:-translate-y-0.5 hover:bg-yellow-500 sm:w-auto"
            >
              <Home className="h-5 w-5" />
              Go to Home
            </Link>
            <button
              type="button"
              onClick={() => window.history.back()}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3 font-semibold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-yellow-300 hover:text-slate-950 sm:w-auto"
            >
              <ArrowLeft className="h-5 w-5" />
              Go Back
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </section>
  );
};

export default NotFound;
